"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Auth_1 = __importDefault(require("./Auth"));
const Category_1 = __importDefault(require("./Category"));
const Menu_1 = __importDefault(require("./Menu"));
const Merchant_1 = __importDefault(require("./Merchant"));
const MerchantPrinter_1 = __importDefault(require("./MerchantPrinter"));
const Order_1 = __importDefault(require("./Order"));
const AppOrder_1 = __importDefault(require("./AppOrder"));
const AppMenu_1 = __importDefault(require("./AppMenu"));
const PromoCode_1 = __importDefault(require("./PromoCode"));
const Logger_1 = __importDefault(require("./Logger"));
exports.default = {
    auth: new Auth_1.default(),
    category: new Category_1.default(),
    menu: new Menu_1.default(),
    merchant: new Merchant_1.default(),
    merchantPrinter: new MerchantPrinter_1.default(),
    order: new Order_1.default(),
    appOrder: new AppOrder_1.default(),
    appMenu: new AppMenu_1.default(),
    PromoCode: new PromoCode_1.default(),
    Logger: new Logger_1.default(),
};
//# sourceMappingURL=index.js.map